export default {
  name: 'Footer',
  displayName: {
    en: 'Footer',
    ja: 'フッター',
  },
  defaultWidth: 375,
  defaultHeight: 300,
  resizeX: true,
  resizeY: true,
  screens: {
    desktop: {
      width: 1200,
      height: 344,
    },
    tablet: {
      width: 768,
      height: 501,
    },
    mobile: {
      width: 375,
      height: 531,
    },
  },
  props: [
    {
      name: 'onMenuItemPress',
      type: 'action',
      displayName: {
        en: 'Menu Item Action',
        ja: 'メニュー項目アクション',
      },
    },
    {
      name: 'onLegalLinkPress',
      type: 'action',
      displayName: {
        en: 'Legal Link Action',
        ja: '法的リンクアクション',
      },
    },
    {
      name: 'menuListActions',
      type: 'action',
      displayName: {
        en: 'Menu List Actions',
        ja: 'メニューリストアクション',
      },
      reference: 'items',
    },
  ],
  childComponents: [
    {
      name: 'logo',
      displayName: {
        en: 'Logo',
        ja: 'Logo',
      },
      props: [
        {
          name: 'logoText',
          displayName: {
            en: 'Logo Text',
            ja: 'ロゴテキスト',
          },
          type: 'text',
          default: 'LOGO',
        },
        {
          name: 'imageLogo',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
          default: [],
        },
      ],
    },
    {
      name: 'menuList',
      displayName: {
        en: 'Menu Lists',
        ja: 'Menu Lists',
      },
      props: [
        {
          name: 'items',
          displayName: {
            en: 'Menu Items',
            ja: 'メニュー項目',
          },
          type: 'dynamicList',
          default: [
            {
              id: 'group-1753747405526',
              text: 'メニュー',
              type: 'group',
              children: [
                {
                  id: 'item-1753748949732',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748952101',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748954690',
                  text: 'メニュー',
                  type: 'item',
                },
              ],
            },
            {
              id: 'group-1753748963348',
              text: 'メニュー',
              type: 'group',
              children: [
                {
                  id: 'item-1753748968487',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748971252',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748974597',
                  text: 'メニュー',
                  type: 'item',
                },
              ],
            },
            {
              id: 'group-1753748979319',
              text: 'メニュー',
              type: 'group',
              children: [
                {
                  id: 'item-1753748984234',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748986800',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753748989770',
                  text: 'メニュー',
                  type: 'item',
                },
              ],
            },
            {
              id: 'group-1753748993748',
              text: 'メニュー',
              type: 'group',
              children: [
                {
                  id: 'item-1753749000113',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753749003482',
                  text: 'メニュー',
                  type: 'item',
                },
                {
                  id: 'item-1753749006037',
                  text: 'メニュー',
                  type: 'item',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'bottomContent',
      displayName: {
        en: 'Bottom Content',
        ja: 'ボトムコンテンツ',
      },
      props: [
        {
          name: 'copyrightText',
          displayName: {
            en: 'Copyright Text',
            ja: '著作権テキスト',
          },
          type: 'text',
          default: '© Company Inc. 2025',
        },
      ],
    },
    {
      name: 'legalLinks',
      displayName: {
        en: 'Legal Links',
        ja: '法的リンク',
      },
      props: [
        {
          name: 'links',
          displayName: {
            en: 'Legal Links',
            ja: '法的リンク',
          },
          type: 'dynamicList',
          default: [
            { text: '運営会社', href: '#company' },
            { text: 'プライバシーポリシー', href: '#privacy' },
          ],
        },
      ],
    },
  ],
  style: {
    backgroundColor: true,
    text: true,
    color: true,
    paddingHorizontal: true,
    paddingVertical: true,
  },
};
